import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromUserEnroll from './data-access/reducers';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(fromUserEnroll.userEnrollFeatureKey, fromUserEnroll.reducer)]
})
export class UserEnrollmentConfigurationModule {}
